import {GetCustomerLicensesRoutine} from '~modules/Companies/redux-routines';
import {AssignLicenseEditRoutine, RemoveLicenseFromCustomerRoutine} from '~modules/Licenses/redux-routines';

export const initialState = {
  data: [],
  error: null,
  isLoading: false,
};

export const customersLicensesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetCustomerLicensesRoutine.REQUEST:
    case AssignLicenseEditRoutine.REQUEST:
    case RemoveLicenseFromCustomerRoutine.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GetCustomerLicensesRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    }
    case RemoveLicenseFromCustomerRoutine.SUCCESS: {
      return {
        ...state,
        data: state.data.filter(i => i.licenseId !== action.payload),
        isLoading: false,
      };
    }
    case GetCustomerLicensesRoutine.FAILURE:
    case AssignLicenseEditRoutine.FAILURE:
    case RemoveLicenseFromCustomerRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
